import { useCallback, useState } from 'react';
function useMutableValue(initialState) {
  const [mutableValue, setMutableValue] = useState(initialState);
  const resetValue = useCallback(() => setMutableValue(initialState), [initialState]);
  return [mutableValue, setMutableValue, initialState, resetValue];
}
export default useMutableValue;